import { createStore } from 'vuex'
import userStore from './modules/userStore';
import sideOption from "@/store/modules/sideOption";

export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    userStore,
    sideOption
  }
})
